export default __webpack_public_path__ + "static/media/fireHands.36b6098b.jpg";